'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lang = require('lodash/lang');

var _redux = require('redux');

var _Constants = require('../actions/Constants');

var Constants = _interopRequireWildcard(_Constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * Handles the creation status of the application.
 * @param {Boolean} state - Current created status.
 * @param {FSA} action - The dispatched action.
 * @returns {Boolean} The new created status.
 */
var created = function created() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case Constants.POST_CREATE_APP_COMPLETE:
      return !action.error ? true : state;
    default:
      return state;
  }
};

/**
 * Handles the ID of the application.
 * @param {String} state - Current ID.
 * @param {FSA} action - The dispatched action.
 * @returns {String} The new ID.
 */
var id = function id() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case Constants.APP_SUBMIT_FAILED:
      window.scrollTo(0, 0);
      return state;
    case Constants.POST_CREATE_APP_COMPLETE:
      return !action.error ? action.payload.data.id : state;
    default:
      return state;
  }
};

/**
 * Handles the quote data for the application.
 * @param {Object} state - Current quote information.
 * @param {FSA} action - The dispatched action.
 * @returns {Object} - New quote information.
 */
var quote = function quote(state, action) {
  if ((0, _lang.isUndefined)(state)) {
    return {
      reference_id: null,
      price: null,
      information: null,
      content: [],
      links: []
    };
  }
  switch (action.type) {
    case Constants.GET_APP_QUOTE_COMPLETE:
      return !action.error ? {
        price: action.payload.data.quote.price,
        reference_id: action.payload.data.quote.reference_id,
        information: action.payload.data.quote.information,
        total_for_recurring_payments: action.payload.data.quote.total_for_recurring_payments,
        monthly_payment: action.payload.data.quote.monthly_payment,
        first_and_last: action.payload.data.quote.first_and_last,
        first_payment: action.payload.data.quote.first_payment,
        policy_fee: action.payload.data.quote.policy_fee,
        content: action.payload.data.content,
        links: action.payload.data.links
      } : {
        price: null,
        reference_id: null,
        information: action.payload.messages,
        content: [],
        links: []
      };
    case Constants.GET_QUOTE_NUMBER:
      return {
        price: state.price,
        reference_id: action.payload.reference_id,
        information: state.information,
        total_for_recurring_payments: state.total_for_recurring_payments,
        monthly_payment: state.monthly_payment,
        first_and_last: state.first_and_last,
        first_payment: state.first_payment,
        policy_fee: state.policy_fee,
        content: state.content,
        links: state.links
      };
    case Constants.SET_LOADING_TRUE:
      return _extends({}, state, {
        loading: true
      });
    case Constants.SET_MAIL_STATUS:
      return _extends({}, state, {
        loading: true,
        mailStatus: 'sending'
      });
    case Constants.RESET_QUOTE:
      return {
        price: null,
        reference_id: null,
        information: action.payload.data.messages,
        content: [],
        links: []
      };
    case Constants.EMAIL_SENT:
      return _extends({}, state, {
        loading: false,
        mailStatus: 'sent'
      });
    case Constants.EMAIL_FAIL:
      return _extends({}, state, {
        loading: false,
        mailStatus: 'failed'
      });
    default:
      return state;
  }
};

/**
 * Handles the confirmation text for the application.
 * @param {Object} state - Current confirmation information.
 * @param {FSA} action - The dispatched action.
 * @returns {Object} - New confirmation information.
 */
var confirmation = function confirmation(state, action) {
  if ((0, _lang.isUndefined)(state)) {
    return {
      title: null,
      logos: [],
      header_text: null,
      body: [],
      legal_text: null,
      confirmed: false
    };
  }
  switch (action.type) {
    case Constants.GET_CONFIRMATION_TEXT_COMPLETE:
      return !action.error ? {
        application_id: action.payload.data.application_id,
        title: action.payload.data.title,
        logos: action.payload.data.logos,
        header_text: action.payload.data.header_text,
        body: action.payload.data.body,
        legal_text: action.payload.data.legal_text,
        confirmed: true
      } : _extends({}, state, {
        error: action.payload.messages
      });
    default:
      return state;
  }
};

/**
 * Handles the applicant status for the application.
 * @param {Object} state - Current applicant status.
 * @param {FSA} action - The dispatched action.
 * @returns {Object} - New applicant status.
 */
var applicants = function applicants() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { created: false };
  var action = arguments[1];

  switch (action.type) {
    case Constants.POST_CREATE_APPLICANT_COMPLETE:
      return !action.error ? {
        created: true
      } : _extends({}, state, {
        error: action.payload.messages
      });
    default:
      return state;
  }
};

var payment = function payment() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { paid: false };
  var action = arguments[1];

  switch (action.type) {
    case Constants.POST_MAKE_PAYMENT_COMPLETE:
      return !action.error ? {
        paid: true,
        amount: action.payload.data.pending,
        pending: Math.round(action.payload.data.pending * 100) / 100,
        reference_id: action.payload.data.reference_id
      } : _extends({}, state, {
        error: action.payload.messages.map(function (error) {
          return { message: error };
        })
      });
    default:
      return state;
  }
};

var paymentDetails = function paymentDetails() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    paymentDetails: null
  };
  var action = arguments[1];

  switch (action.type) {
    case Constants.GET_FAILED_DETAILS_COMPLETE:
      return !action.error ? {
        loaded: true,
        paymentDetails: action.payload.data
      } : _extends({}, state, {
        error: action.payload.messages
      });
    default:
      return state;
  }
};

var processPayment = function processPayment() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    completed: false
  };
  var action = arguments[1];

  switch (action.type) {
    case Constants.PROCESS_FAILED_PAYMENTS_COMPLETE:
      return !action.error ? _extends({}, state, {
        completed: true,
        response: action.payload
      }) : _extends({}, state, {
        error: action.payload.messages,
        completed: false
      });
    default:
      return state;
  }
};

var contactForm = function contactForm() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { formSubmitted: false };
  var action = arguments[1];

  switch (action.type) {
    case Constants.POST_CONTACT_FORM_COMPLETE:
      return !action.error ? { formSubmitted: true, data: action.data } : _extends({}, state, {
        error: action.payload
      });

    case Constants.RESET_CONTACT_FORM:
      return { formSubmitted: false };
    default:
      return state;
  }
};

exports.default = (0, _redux.combineReducers)({
  created: created,
  id: id,
  quote: quote,
  confirmation: confirmation,
  applicants: applicants,
  payment: payment,
  paymentDetails: paymentDetails,
  processPayment: processPayment,
  contactForm: contactForm
});


//////////////////
// WEBPACK FOOTER
// ./src/v2/reducers/application.js
// module id = 1712
// module chunks = 0